module.exports = __webpack_public_path__ + "static/media/dashboard.8c4abbb3.svg";